import { render, staticRenderFns } from "./perCT.vue?vue&type=template&id=1f59ef0b&scoped=true"
import script from "./perCT.vue?vue&type=script&lang=js"
export * from "./perCT.vue?vue&type=script&lang=js"
import style0 from "./perCT.vue?vue&type=style&index=0&id=1f59ef0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59ef0b",
  null
  
)

export default component.exports